import Vue from 'vue'
import Vuex from 'vuex'
import {listMyTasks, list, listByUser, listFilters, nextCreatedTasks, nextPendingTasks, nextEndedTasks, getTasksRestrictionsCodes} from '@/helpers/api/tasks'
import {listAdditionalLikely} from '@/helpers/api/additionals'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		misTareasInfoCreadas: {
			status: 99,
			count: 0,
			data: [],
		},
		misTareasInfoPendientes: {
			status: 99,
			count: 0,
			data: [],
		},
		misTareasInfoFinalizadas: {
			status: 99,
			count: 0,
			data: [],
			solution_speed: null,
			waiting_time: null,
		},
		tareasbyUser: {
			status: 99,
			data: []
		},
		listadoTareas: {
			status: 99,
			count: 0,
			total_tasks: 0,
			data: []
		},
		listadoTareasTotal: 0,
		createTareaModal: false,
		weeklyDashboardModal: false,
		draftToLoad: null,
		creatingPossibleAdditional: false,
		listingOrder: 1,
		selectedType: 2,
		currentTarea: null,
		borradorTarea: null,
		taskCodes: [],
		taskCreators: [],
		taskResponsables: [],
		taskFilterCodes: [],
		loadingTaskCodes: false,
		loadingTaskFilters: false,
		loadingMyTasks: false,
		loadingMyTasksRequestKey: null,
		loadingChangeVisualizationStatus: [],
		listadoTareasPages: {
			3: 1,
			4: 1,
		},
		searchFilter: null,
		creatorFilter: [],
		responsableFilter: [],
		codeFilter: [],
	},
	mutations: {
		setMisTareasInfoCreadas(state, tareas){
			state.misTareasInfoCreadas = tareas
		},
		setMisTareasInfoPendientes(state, tareas){
			state.misTareasInfoPendientes = tareas
		},
		setMisTareasInfoFinalizadas(state, tareas){
			state.misTareasInfoFinalizadas = tareas
		},
		setListadoTareas(state, tareas){
			state.listadoTareas = tareas
			state.listadoTareasTotal = tareas.total_tasks
		},
		setTareasbyUser(state, tareas){
			state.tareasbyUser = tareas
		},
		setCurrentTarea(state, tarea){
			state.currentTarea = tarea
		},
		setBorradorTarea(state, tarea){
			state.borradorTarea = tarea
		},
		setSelectedType(state, type){
			state.selectedType = type
		},
		setSearchFilter(state, search){
			state.searchFilter = search
		},
		setListingOrder(state){
			let currentStatus = state.listingOrder
			if(currentStatus === 4){
				currentStatus = 1
			}
			else{
				currentStatus++
			}
			state.listingOrder = currentStatus
		},
		setCreateTareaModal(state, status){
			state.createTareaModal = status
			if(!status){
				state.draftToLoad = null
			}
		},
		setDraftToLoad(state, draft){
			state.draftToLoad = draft
		},
		setWeeklyDashboardModal(state, status){
			state.weeklyDashboardModal = status
		},
		addLoadingChangeVisualizationStatus(state, newItemID){
			const changingStatus = [...state.loadingChangeVisualizationStatus]
			const found = changingStatus.find((item) => item === newItemID)
			if(!found){
				changingStatus.push(newItemID)
			}
			state.loadingChangeVisualizationStatus = changingStatus
		},
		removeLoadingChangeVisualizationStatus(state, itemID){
			const changingStatus = [...state.loadingChangeVisualizationStatus]
			const foundIndex = changingStatus.findIndex((item) => item === itemID)
			if(foundIndex !== -1){
				changingStatus.splice(foundIndex, 1)
			}
			state.loadingChangeVisualizationStatus = changingStatus
		},
		setTaskCodes(state, taskCodes){
			state.taskCodes = taskCodes
		},
		setTaskCreators(state, taskCreators){
			state.taskCreators = taskCreators
		},
		setTaskResponsables(state, taskResponsables){
			state.taskResponsables = taskResponsables
		},
		setTaskFilterCodes(state, taskFilterCodes){
			state.taskFilterCodes = taskFilterCodes
		},
		setLoadingTaskCodes(state, status){
			state.loadingTaskCodes = status
		},
		setLoadingTaskFilters(state, status){
			state.loadingTaskFilters = status
		},
		setLoadingMyTasks(state, status){
			state.loadingMyTasks = status
		},
		setLoadingMyTasksRequestKey(state, value){
			state.loadingMyTasksRequestKey = value
		},
		setCreatorFilter(state, value){
			state.creatorFilter = value
		},
		setResponsableFilter(state, value){
			state.responsableFilter = value
		},
		setCodeFilter(state, value){
			state.codeFilter = value
		},
		setListadoTareasPage(state, {type, page}){
			if(type !== 3 && type !== 4){
				return
			}
			const normalizedPage = Math.max(1, parseInt(page, 10) || 1)
			state.listadoTareasPages = {
				...state.listadoTareasPages,
				[type]: normalizedPage
			}
		},
		resetForProject(state){
			state.misTareasInfoCreadas = {status: 99, count: 0, data: []}
			state.misTareasInfoPendientes = {status: 99, count: 0, data: []}
			state.misTareasInfoFinalizadas = {
				status: 99,
				count: 0,
				data: [],
				solution_speed: null,
				waiting_time: null,
			}
			state.tareasbyUser = {status: 99, data: []}
			state.listadoTareas = {status: 99, count: 0, total_tasks: 0, data: []}
			state.listadoTareasTotal = 0
			state.taskCodes = []
			state.taskCreators = []
			state.taskResponsables = []
			state.taskFilterCodes = []
			state.loadingTaskCodes = false
			state.loadingTaskFilters = false
			state.loadingMyTasks = false
			state.loadingMyTasksRequestKey = null
			state.listadoTareasPages = {3: 1, 4: 1}
			state.searchFilter = null
			state.creatorFilter = []
			state.responsableFilter = []
			state.codeFilter = []
			state.currentTarea = null
			state.borradorTarea = null
			state.draftToLoad = null
			state.createTareaModal = false
			state.weeklyDashboardModal = false
			state.loadingChangeVisualizationStatus = []
		},
	},
	actions: {
		async getTaskCodes(context, query = {}){
			const request = getProjectRequest(query.project_id)
			context.commit('setLoadingTaskCodes', true)
			const task_codes = await getTasksRestrictionsCodes(query)
			if(isCurrentProjectRequest(request.projectId, request.generation) && task_codes.code === 200){
				context.commit('setTaskCodes', task_codes.task_codes)
			}
			if(isCurrentProjectRequest(request.projectId, request.generation)) context.commit('setLoadingTaskCodes', false)
		},
		async getTaskFilters(context, query){
			const request = getProjectRequest(query.project_id)
			let status = 1
			if(context.state.selectedType === 4){
				status = 3
			}
			context.commit('setLoadingTaskFilters', true)
			const filters = await listFilters({
				project_id: query.project_id,
				status
			})
			if(isCurrentProjectRequest(request.projectId, request.generation) && filters.code === 200){
				context.commit('setTaskCreators', filters.creators || [])
				context.commit('setTaskResponsables', filters.responsables || [])
				context.commit('setTaskFilterCodes', filters.codes || [])
			}
			if(isCurrentProjectRequest(request.projectId, request.generation)) context.commit('setLoadingTaskFilters', false)
		},
		async getMyTasks(context, query){
			const request = getProjectRequest(query.project_id)
			let status = 1
			let page = 1
			let per_page = 50
			const selectedType = context.state.selectedType
			if(context.state.selectedType === 4){
				status = 3
			}
			if(selectedType === 3 || selectedType === 4){
				page = context.state.listadoTareasPages[selectedType] || 1
			}
			if(query.page){
				page = query.page
			}
			if(query.clear){
				context.commit('setCreatorFilter', [])
				context.commit('setResponsableFilter', [])
				context.commit('setCodeFilter', [])
				if(selectedType === 3 || selectedType === 4){
					page = 1
					context.commit('setListadoTareasPage', {type: selectedType, page})
				}
			}
			if(selectedType === 3 || selectedType === 4){
				context.commit('setListadoTareasPage', {type: selectedType, page})
			}
			const activeSearch = query.search !== undefined ? query.search : context.state.searchFilter

			const requestKey = JSON.stringify({
				project_id: query.project_id,
				selectedType,
				status,
				page,
				order: context.state.listingOrder,
				search: activeSearch || '',
				creator: context.state.creatorFilter,
				responsable: context.state.responsableFilter,
				code: context.state.codeFilter
			})
			if(context.state.loadingMyTasks && context.state.loadingMyTasksRequestKey === requestKey){
				return
			}
			context.commit('setLoadingMyTasks', true)
			context.commit('setLoadingMyTasksRequestKey', requestKey)

			try{
				const data = {
					project_id: query.project_id,
					status,
					order: context.state.listingOrder,
					start: per_page * (page - 1),
					limit: per_page,
					filtered_creator_users: context.state.creatorFilter,
					filtered_resp_users: context.state.responsableFilter,
					filtered_code_ids: context.state.codeFilter,
					search: activeSearch
				}
				if(context.state.selectedType === 2){
					context.commit('setMisTareasInfoCreadas', Object.assign(context.state.misTareasInfoCreadas, {status: 99}))
					context.commit('setMisTareasInfoPendientes', Object.assign(context.state.misTareasInfoPendientes, {status: 99}))
					context.commit('setMisTareasInfoFinalizadas', Object.assign(context.state.misTareasInfoFinalizadas, {status: 99}))
					const tareas = await listMyTasks(data)
					if(isCurrentProjectRequest(request.projectId, request.generation) && tareas.code === 200){
						context.commit('setMisTareasInfoCreadas', {
							status: 1,
							count: tareas.my_created_tasks_total,
							data: tareas.my_created_tasks,
						})
						context.commit('setMisTareasInfoPendientes', {
							status: 1,
							count: tareas.my_tasks_total,
							data: tareas.my_tasks,
						})
						context.commit('setMisTareasInfoFinalizadas', {
							status: 1,
							count: tareas.my_ended_tasks_total,
							data: tareas.my_ended_tasks,
							solution_speed: tareas.my_solution_speed,
							waiting_time: tareas.my_waiting_time_last
						})
					}
				}
				else if(context.state.selectedType === 3 || context.state.selectedType === 4){
					let listing = Object.assign(context.state.listadoTareas, {status: 99})
					context.commit('setListadoTareas', listing)
					context.dispatch('getTaskFilters', {project_id: query.project_id})
					data.filtered_creator_users = context.state.creatorFilter
					data.filtered_resp_users = context.state.responsableFilter
					data.filtered_code_ids = context.state.codeFilter
					const taskList = await list(data)
					if(isCurrentProjectRequest(request.projectId, request.generation) && taskList.code === 200){
						context.commit('setListadoTareas', {
							status: 1,
							count: taskList.tasks.length,
							data: taskList.tasks,
							total_tasks: taskList.total_tasks,
						})
					}
				}
				else if(context.state.selectedType === 5){
					let listing = Object.assign(context.state.tareasbyUser, {status: 99})
					context.commit('setTareasbyUser', listing)
					const taskList = await listByUser(data)
					if(isCurrentProjectRequest(request.projectId, request.generation) && taskList.code === 200){
						context.commit('setTareasbyUser', {
							status: 1,
							data: taskList.tasks_indicators
						})
					}
				}
			} finally {
				if(isCurrentProjectRequest(request.projectId, request.generation)){
					context.commit('setLoadingMyTasks', false)
					context.commit('setLoadingMyTasksRequestKey', null)
				}
			}

		},
		async getMyNextCreatedTasks(context, query){
			const request = getProjectRequest(query.project_id)
			let page = 1
			let per_page = 10
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				order: query.order,
				start: per_page * (page - 1),
				limit: per_page,
			}
			context.commit('setMisTareasInfoCreadas', Object.assign(context.state.misTareasInfoCreadas, {status: 99}))
			const tareas = await nextCreatedTasks(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && tareas.code === 200){
				context.commit('setMisTareasInfoCreadas', {
					status: 1,
					count: tareas.my_created_tasks_total,
					data: tareas.my_created_tasks,
				})
			}	
		},
		async getMyNextPendingTasks(context, query){
			const request = getProjectRequest(query.project_id)
			let page = 1
			let per_page = 10
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				order: query.order,
				start: per_page * (page - 1),
				limit: per_page,
			}
			context.commit('setMisTareasInfoPendientes', Object.assign(context.state.misTareasInfoPendientes, {status: 99}))
			const tareas = await nextPendingTasks(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && tareas.code === 200){
				context.commit('setMisTareasInfoPendientes', {
					status: 1,
					count: tareas.my_tasks_total,
					data: tareas.my_tasks,
				})
			}	
		},
		async getMyNextEndedTasks(context, query){
			const request = getProjectRequest(query.project_id)
			let page = 1
			let per_page = 10
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				order: query.order,
				start: per_page * (page - 1),
				limit: per_page,
			}
			context.commit('setMisTareasInfoFinalizadas', Object.assign(context.state.misTareasInfoFinalizadas, {status: 99}))
			const tareas = await nextEndedTasks(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && tareas.code === 200){
				context.commit('setMisTareasInfoFinalizadas', {
					status: 1,
					count: tareas.my_ended_tasks_total,
					data: tareas.my_ended_tasks,
				})
			}	
		},
		async getAdditionalsLikely(context, query){
			let page = 1
			let per_page = 50
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				statuses: query.statuses,
				order: context.state.listingOrder,
				start: per_page * (page - 1),
				limit: per_page
			}

			let listing = Object.assign(context.state.listadoTareas, {status: 99})
			context.commit('setListadoTareas', listing)
			const additionals = await listAdditionalLikely(data)
			if(additionals.code === 200){
				context.commit('setListadoTareas', {
					status: 1,
					count: additionals.additional.length,
					data: additionals.additional,
					total_tasks: additionals.total_additional,
				})
			}
		},
		updateTaskLocally(context, newTaskData){
			const creada = context.state.misTareasInfoCreadas.data.findIndex((task) => { return task.id === newTaskData.id })
			const pendiente = context.state.misTareasInfoPendientes.data.findIndex((task) => { return task.id === newTaskData.id })
			const finalizada = context.state.misTareasInfoFinalizadas.data.findIndex((task) => { return task.id === newTaskData.id })
			const list = context.state.listadoTareas.data.findIndex((task) => { return task.id === newTaskData.id })
			if(creada !== -1){
				let creadas = [...context.state.misTareasInfoCreadas.data]
				creadas[creada] = newTaskData
				context.commit('setMisTareasInfoCreadas', {
					status: 1,
					count: context.state.misTareasInfoCreadas.count,
					data: creadas
				})
			}
			if(pendiente !== -1){
				let pendientes = [...context.state.misTareasInfoPendientes.data]
				pendientes[pendiente] = newTaskData
				context.commit('setMisTareasInfoPendientes', {
					status: 1,
					count: context.state.misTareasInfoPendientes.count,
					data: pendientes
				})
			}
			if(finalizada !== -1){
				let finalizadas = [...context.state.misTareasInfoFinalizadas.data]
				finalizadas[finalizada] = newTaskData
				context.commit('setMisTareasInfoFinalizadas', {
					status: 1,
					count: context.state.misTareasInfoFinalizadas.count,
					data: finalizadas
				})
			}
			if(list !== -1){
				let lists = [...context.state.listadoTareas.data]
				lists[list] = newTaskData
				context.commit('setListadoTareas', {
					status: 1,
					count: context.state.listadoTareas.count,
					data: lists,
					total_tasks: context.state.listadoTareas.total_tasks
				})
			}
		}
	},
	getters: {
		currentTarea: state => {
			return state.currentTarea
		}
	}
})

export default store
